const domainsConfig = Object.freeze({
  "register.beko.com": "fc07d35f-9ef2-4d38-ab7e-e5092208160e",
  "register.grundig.com": "01924d72-0155-7435-a470-caeb552f88ed",
  "register.arctic.ro": "01924724-e206-73c9-a863-b0001c065f81",
  "register.elektrabregenz.com": "018e8943-7b8d-7e69-930b-d14b75254e24",
});

export default domainsConfig;
export { domainsConfig };
